module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_Watford.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_Watford.png
// module id = 2093
// module chunks = 4